import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireforcorporateeventsinpune() {



    const cardData =
    {
        keyword: 'Urbania Hire for Corporate Events in Pune ',
        heading: 'Urbania on rent in pune: Urbania Hire for Corporate Events in Pune ',
        headingDescription: 'Urbania On Rent in Pune offers premium Urbania hire services for corporate events in Pune, ensuring comfortable, punctual, and professional group transportation for businesses and organizations. Our well-maintained Force Urbania fleet is ideal for conferences, seminars, exhibitions, corporate meetings, employee movement, and executive travel across the city. With experienced chauffeurs, flexible one-way and round-trip rental options, and timely doorstep pickup from major business hubs including Hinjewadi, Baner, Wakad, Kharadi, Magarpatta, Hadapsar, and Pune Airport, we deliver a smooth and stress-free corporate travel experience. Backed by 24/7 booking support, strict safety standards, and reliable service, Urbania On Rent in Pune stands out as the trusted choice for corporate event transportation in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical landmark and a symbol of Maratha power. Once the administrative seat of Bajirao I, the fort complex featured grand halls, fountains, and courtyards. Although a major fire destroyed much of the structure, the massive stone walls, gates like the Delhi Darwaza, and remaining ruins still reflect its former grandeur. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit heritage attraction."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Aga Khan Palace is a significant monument linked to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi. Surrounded by lush gardens and Italian-style arches, the palace offers a peaceful yet historically powerful experience."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Sinhagad Fort stands atop a rugged hill in the Sahyadri range and is renowned for the heroic sacrifice of Tanaji Malusare in 1670. The fort offers breathtaking panoramic views of Pune and surrounding valleys. Visitors can trek or drive to explore ancient ramparts, memorials, and gates. Local food stalls serving traditional pithla-bhakri add to the authentic experience, making it a favorite spot for history lovers and adventure seekers."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The beautifully adorned idol, decorated with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations with processions and cultural events. The temple trust is also known for its social and charitable initiatives, making it both a spiritual and cultural landmark."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in a busy area, the temple offers a calm and meditative atmosphere. The monolithic pillars, circular Nandi mandap, and ancient carvings showcase early Indian craftsmanship. It is one of Pune’s lesser-known yet spiritually rich heritage sites."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar to preserve Indian art and culture. Exhibits include musical instruments, sculptures, lamps, utensils, and traditional household items. The recreated Mastani Mahal is a major highlight. The museum offers a deep insight into India’s cultural diversity and traditional craftsmanship."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic city views after climbing 103 stone steps. The hilltop temple complex dates back to the Peshwa era and is dedicated to Lord Shiva and Goddess Parvati. Smaller temples and a museum enrich the visit. Sunrise and sunset views from the hill are especially popular among locals and tourists."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-famous center for meditation and mindfulness. Spread across landscaped gardens, it offers meditation programs, wellness therapies, and spiritual retreats. Visitors from across the globe come here seeking inner peace, relaxation, and personal transformation, making it an international spiritual destination."
            },
            {
                "title": "Pu La Deshpande Garden",
                "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for morning walks, family outings, and photography, the garden blends Japanese aesthetics with Indian natural beauty, offering a serene green escape."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. The vast reservoir, cool breeze, and surrounding hills create a refreshing atmosphere, especially during monsoon and evenings. Street vendors selling corn and tea add local charm. It also serves as a gateway to Sinhagad Fort, making it a scenic leisure destination."
            }
        ],



    "services": [
{
"name": "Urbania for Corporate Events Pune",
"description": "Urbania for Corporate Events Pune provides professional and well-organized transportation for corporate functions, seminars, launches, and business gatherings. With modern Urbania vehicles, trained chauffeurs, and punctual service, this option ensures smooth and comfortable group movement for corporate guests and employees."
},
{
"name": "Urbania Corporate Bus Hire Pune",
"description": "Urbania Corporate Bus Hire Pune offers reliable and efficient transportation solutions for offices, IT companies, and corporate houses. Ideal for employee movement, meetings, and official events, the service includes well-maintained buses, disciplined drivers, and corporate-friendly service standards."
},
{
"name": "Urbania for Office Events Pune",
"description": "Urbania for Office Events Pune is designed to support seamless transportation for office parties, annual functions, and internal corporate programs. The service ensures on-time pickups, comfortable seating, and smooth coordination for hassle-free event travel."
},
{
"name": "Urbania for Corporate Meetings Pune",
"description": "Urbania for Corporate Meetings Pune offers punctual and professional travel for executives and teams attending meetings, presentations, and business appointments. With clean vehicles and experienced chauffeurs, this service supports timely and stress-free corporate mobility."
},
{
"name": "Urbania for Employee Transport Pune",
"description": "Urbania for Employee Transport Pune provides safe, reliable, and scheduled transportation for daily staff movement and shift-based travel. Ideal for factories, IT parks, and corporate offices, the service emphasizes punctuality, safety, and consistent vehicle quality."
},
{
"name": "Urbania for Company Tours Pune",
"description": "Urbania for Company Tours Pune delivers comfortable and coordinated group travel for corporate retreats, offsite programs, and business tours. Spacious seating, professional drivers, and smooth ride quality ensure a relaxed travel experience for teams."
},
{
"name": "Urbania Corporate AC Bus Hire Pune",
"description": "Urbania Corporate AC Bus Hire Pune offers fully air-conditioned Urbania buses for premium corporate travel. Suitable for conferences, executive transport, and long-distance business journeys, this service ensures cool interiors, comfort, and professional chauffeur support."
},
{
"name": "Urbania Luxury Corporate Bus Pune",
"description": "Urbania Luxury Corporate Bus Pune provides high-end Urbania vehicles with plush interiors and superior comfort for VIP executives and corporate guests. Ideal for board meetings, premium events, and executive travel, this service delivers a refined and professional travel experience."
},
{
"name": "Urbania for Business Travel Pune",
"description": "Urbania for Business Travel Pune supports efficient and comfortable transportation for day-to-day business requirements, client visits, and executive movement. The service ensures punctual scheduling, courteous chauffeurs, and well-maintained vehicles."
},
{
"name": "Urbania Corporate Group Travel Pune",
"description": "Urbania Corporate Group Travel Pune offers organized transportation for corporate teams traveling together. Perfect for training programs, workshops, and group meetings, this service ensures coordinated travel with spacious seating and reliable service."
},
{
"name": "Urbania for Conference Transport Pune",
"description": "Urbania for Conference Transport Pune provides dependable group transportation for delegates, speakers, and corporate attendees. With precise scheduling, professional drivers, and comfortable buses, this service supports smooth logistics for conferences and large corporate events."
},
{
"name": "Urbania for Corporate Outstation Pune",
"description": "Urbania for Corporate Outstation Pune delivers safe and comfortable long-distance travel for business trips, plant visits, and multi-city corporate tours. Highway-trained chauffeurs and well-maintained vehicles ensure reliable and smooth outstation journeys."
},
{
"name": "Urbania for Team Outings Pune",
"description": "Urbania for Team Outings Pune offers convenient and enjoyable transportation for corporate team outings, picnics, and recreational trips. Spacious Urbania vehicles and professional drivers ensure relaxed and well-managed group travel."
},
{
"name": "Urbania Professional Chauffeur Service Pune",
"description": "Urbania Professional Chauffeur Service Pune provides skilled, uniformed, and background-verified chauffeurs trained in corporate etiquette and safe driving. Ideal for executive and corporate travel, this service emphasizes professionalism, punctuality, and comfort."
},
{
"name": "Corporate Urbania Rental Pune",
"description": "Corporate Urbania Rental Pune offers comprehensive Urbania rental solutions tailored for corporate needs. From employee transport to executive travel and corporate events, the service delivers reliability, flexible rental plans, and high-quality vehicles."
}
],
"tableData": [
["Urbania for Corporate Events Pune", "Urbania Corporate Bus Hire Pune"],
["Urbania for Office Events Pune", "Urbania for Corporate Meetings Pune"],
["Urbania for Employee Transport Pune", "Urbania for Company Tours Pune"],
["Urbania Corporate AC Bus Hire Pune", "Urbania Luxury Corporate Bus Pune"],
["Urbania for Business Travel Pune", "Urbania Corporate Group Travel Pune"],
["Urbania for Conference Transport Pune", "Urbania for Corporate Outstation Pune"],
["Urbania for Team Outings Pune", "Urbania Professional Chauffeur Service Pune"],
["Corporate Urbania Rental Pune", ""]
],








 "whychoose": [
    {
        "WhyChooseheading": "Best Urbania Hire for Corporate Events in Pune",
        "WhyChoosedescription": "Urbania Hire for Corporate Events in Pune is an ideal choice for professional, comfortable, and spacious corporate group travel, suitable for meetings, conferences, seminars, and business events."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania Hire for Corporate Events in Pune offers premium Force Urbania vehicles with modern interiors, ample legroom, and air-conditioning for a smooth and executive travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania Hire for Corporate Events in Pune comes with skilled and professional drivers who understand corporate schedules and routes, ensuring safe, punctual, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania Hire for Corporate Events in Pune for competitive and transparent pricing with no hidden charges, making corporate group travel cost-effective and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Hire for Corporate Events in Pune includes round-the-clock support for bookings, inquiries, and last-minute corporate travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania Hire for Corporate Events in Pune is available for hourly rentals, full-day bookings, conferences, employee transportation, and customized corporate travel packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania Hire for Corporate Events in Pune are regularly serviced and sanitized to ensure a clean, safe, and professional travel environment."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania Hire for Corporate Events in Pune guarantees on-time pickups and dependable service, ensuring smooth and stress-free corporate transportation."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Hire for Corporate Events in Pune available for corporate travel?',
        answer: 'Yes, Urbania Hire for Corporate Events in Pune is available for conferences, meetings, seminars, and all types of corporate travel needs.',
    },
    {
        question: 'How can I book Urbania Hire for Corporate Events in Pune?',
        answer: 'You can easily book Urbania Hire for Corporate Events in Pune through phone, WhatsApp, or online booking for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania Hire for Corporate Events in Pune for group travel?',
        answer: 'Urbania Hire for Corporate Events in Pune offers spacious seating, luxury interiors, professional service, and smooth ride quality, making it ideal for corporate group travel.',
    },
    {
        question: 'Is Urbania Hire for Corporate Events in Pune suitable for conferences and business events?',
        answer: 'Yes, Urbania Hire for Corporate Events in Pune is perfect for corporate trips, conferences, meetings, exhibitions, and business events.',
    },
    {
        question: 'Are drivers experienced with Urbania Hire for Corporate Events in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles for corporate travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania Hire for Corporate Events in Pune?',
        answer: 'Absolutely. Urbania Hire for Corporate Events in Pune allows flexible pickup and drop-off locations across Pune and nearby areas.',
    },
    {
        question: 'Is Urbania Hire for Corporate Events in Pune available 24x7?',
        answer: 'Yes, Urbania Hire for Corporate Events in Pune operates 24x7 to meet corporate travel schedules.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania Hire for Corporate Events in Pune?',
        answer: 'Yes, all vehicles are regularly sanitized and maintained, and strict safety protocols are followed for every corporate trip.',
    },
    {
        question: 'What payment options are available for Urbania Hire for Corporate Events in Pune?',
        answer: 'Urbania Hire for Corporate Events in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your journey to ensure a smooth and stress-free corporate travel experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajit Kulkarni',
        feedback: 'We booked Urbania Hire for Corporate Events in Pune for a business conference. The vehicle was spacious, clean, and very comfortable. Excellent service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rutuja Deshmukh',
        feedback: 'Urbania Hire for Corporate Events in Pune provided outstanding service for our corporate outing. Professional driver and smooth coordination.',
        rating: 5,
    },
];








































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Corporate Events in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-corporate-events-pune.jpg",
  "description": "Urbania Hire for Corporate Events in Pune offers premium Force Urbania bus rental services for corporate meetings, office events, employee transport, conferences, business travel, team outings, and corporate outstation tours. Luxury AC Urbania buses with professional chauffeur-driven service ensure comfort, punctuality, and reliability.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1900",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-corporate-events-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Hire for Corporate Events in Pune | Corporate Bus & Group Travel 
  </title>

  <meta
    name="description"
    content="Book Urbania hire for corporate events in Pune. Luxury AC Urbania buses for office events, corporate meetings, employee transport, conferences, business travel, team outings, and outstation corporate tours with professional chauffeurs."
  />

  <meta
    name="keywords"
    content="Urbania for Corporate Events Pune, Urbania Corporate Bus Hire Pune, Urbania for Office Events Pune, Urbania for Corporate Meetings Pune, Urbania for Employee Transport Pune, Urbania for Company Tours Pune, Urbania Corporate AC Bus Hire Pune, Urbania Luxury Corporate Bus Pune, Urbania for Business Travel Pune, Urbania Corporate Group Travel Pune, Urbania for Conference Transport Pune, Urbania for Corporate Outstation Pune, Urbania for Team Outings Pune, Urbania Professional Chauffeur Service Pune, Corporate Urbania Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniahireforcorporateeventsinpune;